// extracted by mini-css-extract-plugin
export default {"buttons":"styles_buttons__MeJjm","selected":"styles_selected__T8-Gq"};